<template>
  <div>
    <b-container fluid class="mb-5">
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
      <b-row no-gutters class="mt-3 mb-3">
        <b-col style="text-align: right">
          <b-button v-if="this.$route.params.order_master_id
            ? checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Edit',
              true
            )
            : checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Order Create',
              true
            )
          " size="sm" class="btn-action" variant="info" @click="submitForm()">Save</b-button>
        </b-col>
      </b-row>
      <b-card class="mb-1">
        <FormInput :canEditFields="canEditFields" :validateState="validateState" :getErrorMessages="getErrorMessages"
          :data="order_master_obj" :onChangeData="onChangeData" />
      </b-card>

      <b-card class="mb-1" v-if="$store.state.user_obj.client_id == 77">
        <h4>Products</h4>
        <div>
          <b-table small outlined striped hover :items="products" :fields="products_fields">
            <template #top-row="data">
              <b-td>
                <!-- <b-form-input type="text" size="sm" required placeholder v-model="product_obj.channel_sku"></b-form-input> -->
                <b-form-group>
                  <b-form-select size="sm" v-model="product_obj.channel_sku" :options="channel_sku_options" />
                </b-form-group>
              </b-td>
              <b-td>
                <b-form-input type="text" size="sm" required placeholder
                  v-model="product_obj.description"></b-form-input>
              </b-td>
              <b-td>
                <b-form-group>
                  <b-form-input type="text" size="sm" required placeholder v-model="product_obj.price"
                    :state="validateState('price', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('price', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td>
                <b-form-group>
                  <b-form-input type="text" size="sm" required placeholder v-model="product_obj.quantity"
                    :state="validateState('quantity', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('quantity', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td v-if="false">
                <b-form-group>
                  <b-form-input type="text" size="sm" required placeholder v-model="product_obj.vendor"
                    :state="validateState('vendor', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('vendor', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td>
                <b-button class="btn-action" size="sm" variant="info" @click="addProductRow()">Add</b-button>
              </b-td>
            </template>

            <template v-slot:cell(channel_sku)="data">
              <span>{{ data.item.channel_sku }}</span>
            </template>
            <template v-slot:cell(price)="data">
              <span>{{ data.item.price }}</span>
            </template>

            <template v-slot:cell(description)="data">
              <span>{{ data.item.description }}</span>
            </template>

            <template v-slot:cell(quantity)="data">
              <span>{{ data.item.quantity }}</span>
            </template>
            <template v-slot:cell(vendor)="data">
              <span>{{ data.item.vendor }}</span>
            </template>

            <template v-slot:cell(action)="data">
              <b-button class="btn-action" size="sm" variant="danger" @click="removeProductRow(data)">Remove</b-button>
            </template>
          </b-table>
        </div>
      </b-card>

      <b-card class="mb-1" v-if="$store.state.user_obj.client_id == 11">
        <h4>Products</h4>
        <div>
          <b-table small outlined striped hover :items="products" :fields="products_fields">
            <template #top-row="data">
              <b-td>
                <b-form-input type="text" size="sm" required placeholder
                  v-model="product_obj.channel_sku"></b-form-input>
                <!-- <b-form-group>
                  <b-form-select size="sm" v-model="product_obj.channel_sku" :options="channel_sku_options" />
                </b-form-group> -->
              </b-td>
              <b-td>
                <b-form-input type="text" size="sm" required placeholder
                  v-model="product_obj.description"></b-form-input>
              </b-td>
              <b-td>
                <b-form-group>
                  <b-form-input type="text" size="sm" required placeholder v-model="product_obj.price"
                    :state="validateState('price', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('price', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td>
                <b-form-group>
                  <b-form-input type="text" size="sm" required placeholder v-model="product_obj.quantity"
                    :state="validateState('quantity', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('quantity', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td v-if="false">
                <b-form-group>
                  <b-form-input type="text" size="sm" required placeholder v-model="product_obj.vendor"
                    :state="validateState('vendor', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('vendor', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td>
                <b-button class="btn-action" size="sm" variant="info" @click="addProductRow()">Add</b-button>
              </b-td>
            </template>

            <template v-slot:cell(channel_sku)="data">
              <span>{{ data.item.channel_sku }}</span>
            </template>
            <template v-slot:cell(price)="data">
              <span>{{ data.item.price }}</span>
            </template>

            <template v-slot:cell(description)="data">
              <span>{{ data.item.description }}</span>
            </template>

            <template v-slot:cell(quantity)="data">
              <span>{{ data.item.quantity }}</span>
            </template>
            <template v-slot:cell(vendor)="data">
              <span>{{ data.item.vendor }}</span>
            </template>

            <template v-slot:cell(action)="data">
              <b-button class="btn-action" size="sm" variant="danger" @click="removeProductRow(data)">Remove</b-button>
            </template>
          </b-table>
        </div>
      </b-card>

      <b-card class="mb-1" v-if="$store.state.user_obj.client_id != 77 && $store.state.user_obj.client_id != 11">
        <h4>Products</h4>
        <div>
          <b-table small outlined striped hover :items="products" :fields="products_fields">
            <template #top-row="data">
              <b-td style="width: 25%;">
                <model-list-select name="product_search" :list="product_search_options"
                  v-model="product_obj.product_search" placeholder="Search Product" option-value="channel_sku"
                  option-text="product_option" @input="handleOnProductOption">
                </model-list-select>
              </b-td>
              <b-td>
                <b-form-input disabled type="text" size="" required placeholder
                  v-model="product_obj.channel_sku"></b-form-input>
                <!-- <b-form-group>
                  <b-form-select size="sm" v-model="product_obj.channel_sku" :options="channel_sku_options" />
                </b-form-group> -->
              </b-td>
              <b-td>
                <b-form-input disabled type="text" size="" required placeholder
                  v-model="product_obj.description"></b-form-input>
              </b-td>
              <b-td>
                <b-form-group>
                  <b-form-input type="text" size="" required placeholder v-model="product_obj.price"
                    :state="validateState('price', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('price', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td>
                <b-form-group>
                  <b-form-input type="text" size="" required placeholder v-model="product_obj.quantity"
                    :state="validateState('quantity', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('quantity', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td v-if="false">
                <b-form-group>
                  <b-form-input type="text" size="" required placeholder v-model="product_obj.vendor"
                    :state="validateState('vendor', 'product_obj')"></b-form-input>
                  <b-form-invalid-feedback class="txt_normal_text_transform"
                    v-for="error in getErrorMessages('vendor', 'product_obj')" :key="error">{{ error
                    }}</b-form-invalid-feedback>
                </b-form-group>
              </b-td>
              <b-td>
                <b-button class="btn-action" size="sm" variant="info" @click="addProductRow()">Add</b-button>
              </b-td>
            </template>

            <template v-slot:cell(channel_sku)="data">
              <span>{{ data.item.channel_sku }}</span>
            </template>
            <template v-slot:cell(price)="data">
              <span>{{ data.item.price }}</span>
            </template>

            <template v-slot:cell(description)="data">
              <span>{{ data.item.description }}</span>
            </template>

            <template v-slot:cell(quantity)="data">
              <span>{{ data.item.quantity }}</span>
            </template>
            <template v-slot:cell(vendor)="data">
              <span>{{ data.item.vendor }}</span>
            </template>

            <template v-slot:cell(action)="data">
              <b-button class="btn-action" size="sm" variant="danger" @click="removeProductRow(data)">Remove</b-button>
            </template>
          </b-table>
        </div>
      </b-card>

      <h4 class="mt-3">Documents</h4>
      <b-card>
        <div class="search_bar mb-3">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-input id="input-small" type="text" placeholder="Document Name"
                v-model="new_doc_record.name"></b-form-input>
            </b-col>
            <b-col cols="3" class="pl-0 pr-1">
              <b-form-file v-model="new_doc_record.upload_file" placeholder="Choose a file..."></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" variant="info" @click="onAddFile">Add</b-button>
            </b-col>
          </b-row>
        </div>
        <b-table responsive small outlined striped hover :items="document_items" :fields="document_fields">
          <template v-slot:cell(document_name)="data">
            <a :href="data.item.url" target="_blank">
              {{ data.item.document_name }}
            </a>
          </template>

          <template v-slot:cell(created_at)="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.created_at }}
            </div>
          </template>
        </b-table>
      </b-card>

      <b-row no-gutters class="mt-3">
        <b-col style="text-align: right">
          <b-button v-if="this.$route.params.order_master_id
            ? checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Edit',
              true
            )
            : checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Order Create',
              true
            )
          " size="sm" class="btn-action" variant="info" @click="showModal_orderSummary()">Save</b-button>
        </b-col>
      </b-row>

      <b-modal ref="modal_orderSummary" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col><strong>Order Number: </strong>{{ order_master_obj.order_number }}</b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col><strong># of ctns (Optional): </strong>{{ order_master_obj.no_of_ctns }}</b-col>
          </b-row>

          <b-row class="mb-3" v-if="order_master_obj.order_type == 'Collect & Delivery'">
            <b-col><strong>Collection Store: </strong>{{ order_master_obj.collection_store }}</b-col>
          </b-row>

          <b-row class="mb-3" v-if="order_master_obj.order_type == 'Collect & Delivery'">
            <b-col><strong>Collection Date: </strong>{{ order_master_obj.collection_date }}</b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col><strong>Delivery Date: </strong>{{ order_master_obj.scheduled_delivery_date }}</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_orderSummary">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="submitForm()">Confirm</b-btn>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  decimal,
} from "vuelidate/lib/validators";
import FormInput from "./common/FormInput";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect, ModelListSelect } from "vue-search-select";

export default {
  name: "OrderMaseterCreate",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "ERROR_MESSAGES"],
  mixins: [validationMixin, global_function, apiService],
  components: {
    FormInput,
    ModelSelect,
    ModelListSelect
  },
  data() {
    return {
      breadcrumb_items: [
        {
          text: "Order Master",
          to: { name: "order_master" },
        },
        {
          text: "Form",
          active: true,
        },
      ],

      loader: false,
      order_master_obj: {
        order_type: "Collect & Delivery",
        // collection_store: "CS",
        collection_store: null,
        order_date: moment().format("YYYY-MM-DD"),
        // scheduled_delivery_date: moment().add(2, "d").format("YYYY-MM-DD"),
        // collection_date: moment().add(2, "d").format("YYYY-MM-DD"),
        scheduled_delivery_date: '',
        collection_date: '',
        no_of_ctns: '1',
        courier_short_name: "GOLS",
        address_template: null
      },
      products: [],
      product_obj: {
        channel_sku: "",
        price: "",
        quantity: "1",
        vendor: "",
      },
      new_doc_record: {},
      document_items: [],
      document_fields: [
        {
          key: "document_name",
          label: "Document Name"
        },
        {
          key: "created_by",
          label: "Created By"
        },
        {
          key: "created_at",
          label: "Created at"
        }
      ],

      order_status_options: [
        {
          value: "cancel",
          text: "Cancel",
        },
        {
          value: "received",
          text: "Received",
        },
        {
          value: "pending",
          text: "Pending",
        },
        {
          value: "hold",
          text: "Hold",
        },
      ],
      stock_status_options: [
        {
          value: "-",
          text: "-",
        },
        {
          value: "pending",
          text: "Pending",
        },
        {
          value: "available",
          text: "Available",
        },
        {
          value: "committed",
          text: "Committed",
        },
      ],
      order_type_options: [
        {
          value: "Collect & Delivery",
          text: "Collect & Delivery",
        },
        {
          value: "Delivery",
          text: "Delivery",
        },
        {
          value: "Collection",
          text: "Collection only",
        },
      ],
      order_type_2_options: [
      ],
      channel_sku_options: [
        {
          value: null,
          text: "-",
        },
        {
          value: "XXS (Accessories up to 5kg)",
          text: "XXS (Accessories up to 5kg)",
        },
        {
          value: "XS (Backpack - up to 10kg)",
          text: "XS (Backpack - up to 10kg)",
        },
        {
          value: 'S (23" suitcase - up to 20kg)',
          text: 'S (23" suitcase - up to 20kg)',
        },
        {
          value: 'M (27" suitcase - up to 30kg)',
          text: 'M (27" suitcase - up to 30kg)',
        },
        {
          value: 'L (32" suitcase - up to 45kg)',
          text: 'L (32" suitcase - up to 45kg)',
        },
      ],
      district_options: [],
      collection_store_options: [],
      channel_options: [],
      client_options: [],
      product_search_options: [],
      product_descriptions: {},
      products_fields: [
        { key: "search", label: "-" },
        { key: "channel_sku", label: "Channel SKU" },
        { key: "description", label: "Description" },
        { key: "price", label: "Price" },
        { key: "quantity", label: "Quantity" },
        // { key: "vendor", label:"Vendor" },
        { key: "action", label: "Action" },
      ],
      address_template_options: [],
      address_template_data: []
    };
  },
  async created() {
    // await this.getUser();
    await this.getAddresseTemplates();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    if (this.$store.state.user_obj.client_id == 11) {
      this.channel_options = [];
      this.channel_options.push({
        value: 'RMW',
        text: 'RMW',
      });

      this.order_type_options = [];
      this.order_type_options = [
        {
          value: "Collect & Delivery",
          text: "Collect & Delivery",
        },
        {
          value: "Collection",
          text: "Collection",
        },
      ];
    } else {
      for (let i in channels_response.channels) {
        this.channel_options.push({
          value: channels_response.channels[i].name,
          text: channels_response.channels[i].name,
        });
      }
    }

    if (this.$store.state.user_obj.client_id == 11) {
      this.order_type_options = this.order_type_options.map((orderType) => {
        if (orderType.value == "Collect & Delivery") {
          return {
            ...orderType,
            text: "Collect from CCC & Deliver to Client",
          };
        }

        if (orderType.value == "Collection") {
          return {
            ...orderType,
            text: "Collect from Client & Deliver to CCC",
          };
        }

        return orderType;
      });
    }

    let districts_response = await this.getDistricts(
      this.$store.state.user_obj
    );
    for (let i in districts_response.districts) {
      this.district_options.push({
        value: districts_response.districts[i].district,
        text: districts_response.districts[i].district,
      });
    }

    let collection_stores_response = await this.getCollectionStores(
      this.$store.state.user_obj
    );
    for (let i in collection_stores_response.collection_stores) {
      this.collection_store_options.push({
        value: collection_stores_response.collection_stores[i].store_code,
        text:
          collection_stores_response.collection_stores[i].store_code +
          " - " +
          collection_stores_response.collection_stores[i].store_address,
      });
    }

    let clients_response = await this.getClients(this.$store.state.user_obj);
    for (let i in clients_response.clients) {
      this.client_options.push({
        value: clients_response.clients[i].id,
        text: clients_response.clients[i].full_name,
      });
    }

    // default store
    // mapping of store vs user
    let store_user = {
      1130: "CCC",
      1129: "HC",
      1128: "LC",
      1127: "LG",
      1126: "EM",
      1125: "HI",
      1124: "LM",
      1123: "TS",
      1122: "PP",
      203: "PP"
    };
    console.log(this.$store.state.user_obj.user_id);
    if (store_user[this.$store.state.user_obj.user_id]) {
      this.order_master_obj.collection_store = store_user[this.$store.state.user_obj.user_id];
    }

    if (this.$store.state.user_obj.client_id == 77) {
      this.products_fields = [
        { key: "channel_sku", label: "Channel SKU" },
        { key: "description", label: "Description" },
        { key: "price", label: "Price" },
        { key: "quantity", label: "Quantity" },
        // { key: "vendor", label:"Vendor" },
        { key: "action", label: "Action" },
      ];
    } else {
      this.order_master_obj.order_type = 'Delivery';
    }

    this.order_master_obj.channel = this.channel_options[0].value;

    this.order_master_obj = JSON.parse(JSON.stringify(this.order_master_obj));

    this.getProductOptions();

    if (this.$store.state.user_obj.client_id == 101) {
      this.order_type_options = [];
      this.order_type_options = [
        {
          value: "Collect & Delivery",
          text: "Collect & Delivery",
        }
      ];

      this.order_master_obj.order_type = "Collect & Delivery";
      this.order_master_obj = JSON.parse(JSON.stringify(this.order_master_obj));
    }

    if (this.$store.state.user_obj.client_id == 28) {
      this.order_type_options = [];
      this.order_type_options = [
        {
          value: "Delivery",
          text: "Delivery",
        }
      ];

      this.order_master_obj.order_type = "Delivery";
      this.order_master_obj = JSON.parse(JSON.stringify(this.order_master_obj));
    }

    if (this.$route.params.order_master_id) {
      this.edit_mode = true;
    }
    this.initialized = true;
  },
  validations: {
    order_master_obj: {
      order_number: { required },
      order_date: { required },
      channel: { required },
      customer_id: {},
      customer_name: { required },
      customer_phone: { required },
      customer_email: {},
      customer_address: { required },
      customer_company_name: {},
      no_of_ctns: { decimal },
      group_id: {},
      scheduled_delivery_date: {},
      remarks: {},
      tracking_number: { required },
      courier_short_name: { required },
      district: { required },
      preferred_section: {},
      collection_store: {},
      order_type: { required },
      order_type_2: {},
      collection_date: {},
      address_template: {}
    },
    product_obj: {
      channel_sku: { required },
      price: { decimal },
      quantity: { decimal },
      vendor: {},
    },
  },
  computed: {
    canEditFields: function () {
      return [
        {
          type: "select",
          options: this.order_type_options,
          key: "order_type",
          label: "Order Type",
        },
        {
          type: "select",
          options: this.getOrderType2Options(),
          key: "order_type_2",
          label: "",
          hidden: this.$store.state.user_obj.client_id != '11',
        },
        {
          type: "text",
          key: "order_number",
          label: "Order Number",
          onblur: (payload) => {
            console.log(payload);
            this.order_master_obj.tracking_number = payload;
            this.order_master_obj = JSON.parse(
              JSON.stringify(this.order_master_obj)
            );
          },
        },
        {
          type: "date",
          key: "order_date",
          label: "Order Date",
          disable: true
        },
        {
          type: "select",
          options: this.channel_options,
          key: "channel",
          label: "Channel",
        },
        {
          type: "text",
          key: "customer_id",
          label: "Customer ID",
          hidden: true,
        },
        {
          type: "select",
          options: this.address_template_options,
          key: "address_template",
          label: "Address Template",
          onChangeData: (payload) => {
            console.log(payload);
          }
        },
        {
          type: "text",
          key: "customer_name",
          label: "Name",
        },
        {
          type: "text",
          key: "customer_phone",
          label: "Phone",
        },
        {
          type: "text",
          key: "customer_email",
          label: "Email (Optional)",
        },
        {
          type: "select",
          options: this.district_options,
          key: "district",
          label: "District",
        },
        {
          type: "text",
          key: "customer_address",
          label: "Address",
        },
        {
          type: "text",
          key: "customer_company_name",
          label: "Company Name (Optional)",
        },
        {
          type: "text",
          key: "no_of_ctns",
          label: "# of ctns (Optional)",
        },
        {
          type: "text",
          key: "group_id",
          label: "Group ID",
          hidden: true,
        },
        {
          type: "text",
          key: "tracking_number",
          label: "Tracking Number",
        },
        {
          type: "text",
          key: "courier_short_name",
          label: "Courier Short Name",
        },
        {
          type: "select",
          options: this.collection_store_options,
          key: "collection_store",
          label: "Collection Store",
          hidden: this.order_master_obj.order_type != "Collect & Delivery",
        },
        {
          type: "date",
          key: "collection_date",
          label: "Collection Date",
          hidden: this.order_master_obj.order_type != "Collect & Delivery",
        },
        {
          type: "date",
          key: "scheduled_delivery_date",
          label: this.order_master_obj.order_type == "Collection" ? "Collection Date" : "Delivery Date",
        },
        {
          type: "text",
          key: "preferred_section",
          label: "Preferred Section",
          hidden: true,
        },
        {
          type: "textarea",
          key: "remarks",
          label: "Remarks",
        },
        // {
        //     type: "text",
        //     key: "priority",
        //     label: "Priority"
        // },

        // {
        //     type: "select",
        //     options: order_status_options,
        //     key: "order_import_status",
        //     label: "Order Status"
        // },

        // {
        //     type: "select",
        //     options: stock_status_options,
        //     key: "stock_status",
        //     label: "Stock Status"
        // },
      ];
    },
  },
  mounted() { },
  watch: {
    'order_master_obj.address_template': function (newValue) {
      if (newValue) {
        // Find the selected template from address_template_data
        const selectedTemplate = this.address_template_data.find(
          (template) => template.id === newValue
        );

        // If a template is found, populate the order_master_obj fields
        if (selectedTemplate) {
          this.order_master_obj.customer_name = selectedTemplate.name;
          this.order_master_obj.customer_phone = selectedTemplate.phone;
          this.order_master_obj.customer_address = selectedTemplate.address;
          this.order_master_obj.district = selectedTemplate.district;
          this.order_master_obj.remarks = selectedTemplate.remark;

          // Set the new values and validate
          this.$v.order_master_obj.customer_name.$model = selectedTemplate.name;
          this.$v.order_master_obj.customer_phone.$model = selectedTemplate.phone;
          this.$v.order_master_obj.customer_address.$model = selectedTemplate.address;
          this.$v.order_master_obj.district.$model = selectedTemplate.district;
          this.$v.order_master_obj.remarks.$model = selectedTemplate.remark;
        }
      } else {
        // Reset fields if no template is selected
        this.order_master_obj.customer_name = '';
        this.order_master_obj.customer_phone = '';
        this.order_master_obj.customer_address = '';
        this.order_master_obj.district = '';
        this.order_master_obj.remarks = '';
      }

      this.order_master_obj = JSON.parse(JSON.stringify(this.order_master_obj));

      // Reset validation state
      this.$v.$reset();

      // Re-apply validation (to mark all as untouched and then start validation)
      this.$nextTick(() => {
        this.$v.$touch(); // Trigger re-validation
      });
    }
  },

  methods: {
    getOrderType2Options() {
      if (this.order_master_obj.order_type == 'Collect & Delivery') {
        this.order_type_2_options = [
          {
            value: "SO",
            text: "Sales Order",
          },
          {
            value: "RO",
            text: "Repair Order",
          }
        ];
      } else {
        this.order_type_2_options = [
          {
            value: "CR",
            text: "Customer Return",
          },
        ];
      }
      return this.order_type_2_options;
    },
    async getUser() {
      if (!this.$route.params.user_id) {
        this.order_master_obj = {};
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cms_user_get.php",
        data: {
          cms_user_id: this.$route.params.user_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.order_master_obj = response.data.users[0];

      console.log(this.order_master_obj);
    },

    async getProductOptions() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_option_get.php",
        data: {
          cms_user_id: this.$route.params.user_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          channel: this.order_master_obj.channel
        },
      });

      for (let i in response.data.products) {
        this.product_descriptions[response.data.products[i].channel_sku] = response.data.products[i].product_description;
      }

      this.product_search_options = response.data.products;

    },


    validateState(name, objName = "order_master_obj") {
      const { $dirty, $error } = this.$v[objName][name];
      return $dirty ? !$error : null;
    },

    getErrorMessages(key, objName = "order_master_obj") {
      let validators = Object.keys(this.$v[objName][key].$params);
      let errors = validators
        .filter((v) => this.$v[objName][key][v] === false)
        .map((v) => this.ERROR_MESSAGES[v]);
      return errors;
    },

    async submitForm() {
      this.$refs.modal_orderSummary.hide();

      if (this.products.length < 1) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Missing products",
          variant: "danger",
        });
        return;
      }

      // check ctns > 0
      if (this.order_master_obj.no_of_ctns <= 0) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Cartons",
          variant: "danger",
        });
        return;
      }

      if (this.order_master_obj.order_type == 'Collect & Delivery') {
        if (this.order_master_obj.collection_store == null) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Please Select Collection Store",
            variant: "danger",
          });
          return;
        }
      }

      if (this.$store.state.user_obj.client_id == 11) {
        if (this.order_master_obj.order_type_2 == null) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Please Select Order Type",
            variant: "danger",
          });
          return;
        }
      }

      // Check for special characters in order_number and tracking_number
      const containsSpecialChars = (str) => /[&\/?]/g.test(str);

      if (containsSpecialChars(this.order_master_obj.order_number)) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Order number contains invalid characters (&, /, ?). Please remove them.",
          variant: "danger",
        });
        return;
      }

      if (containsSpecialChars(this.order_master_obj.tracking_number)) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Tracking number contains invalid characters (&, /, ?). Please remove them.",
          variant: "danger",
        });
        return;
      }

      this.$v.order_master_obj.$touch();
      if (this.$v.order_master_obj.$anyError) {
        return;
      }

      let params = {
        order_master_obj: this.order_master_obj,
        products: this.products,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id,
      };

      let req_url = "order_master_add.php";

      if (this.$route.params.order_master_id) {
        params.order_master_id = this.$route.params.order_master_id;
        req_url = "order_master_edit.php";
      }

      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: req_url,
        data: params,
      });

      if (response.data.status === "fail") {
        this.loader_full.hide();
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error,
          variant: "danger",
        });
      } else {
        // success, continue to upload file
        await this.onUploadFileBulk(response.data.order_master_id);

        this.loader_full.hide();

        this.$eventHub.$emit("show_modal_message", {
          message_content: "Create Order Success",
        });

        if (response.data.auto_route_assigned) {
          this.$eventHub.$emit("show_auto_route_review", {
            items: [response.data.auto_route_assigned],
          });
        }

        this.$router.go(-1);
      }
    },


    addProductRow() {
      this.$v.product_obj.$touch();
      if (this.$v.product_obj.$anyError) {
        return;
      }

      this.products = [
        ...this.products,
        {
          channel_sku: this.product_obj.channel_sku,
          price: this.product_obj.price,
          description: this.product_obj.description,
          quantity: this.product_obj.quantity,
          vendor: this.product_obj.vendor,
        },
      ];

      this.product_obj = {
        channel_sku: "",
        price: "",
        quantity: "1",
        vendor: "",
      };
      this.$v.$reset();
    },
    removeProductRow(data) {
      let tmp = this.products;
      tmp.splice(data.index, 1);
      this.products = [...tmp];
    },
    onChangeData: function (data) {
      this.order_master_obj = data;
    },
    async lookupProduct(row_product) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_lookup.php",
        data: {
          channel_sku: row_product.channel_sku,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status == "success") {
        row_product.price = response.data.product.sale_price;
        row_product.description = response.data.product.product_description_en;
      } else {
        row_product.price = "";
        row_product.description = "";
      }

      this.product_obj = JSON.parse(JSON.stringify(row_product));
    },

    showModal_orderSummary() {
      this.$refs.modal_orderSummary.show();
    },

    hideModal_orderSummary() {
      this.$refs.modal_orderSummary.hide();
    },

    handleOnProductOption($event) {
      console.log($event);
      this.product_obj.channel_sku = $event;
      this.product_obj.description = this.product_descriptions[$event];
    },

    async onAddFile() {
      if (this.new_doc_record.upload_file == null) {
        return;
      }

      if (this.new_doc_record.name == '') {
        return;
      }
      let doc_record = {
        document_name: this.new_doc_record.name,
        upload_file: this.new_doc_record.upload_file,
        created_by: '-',
        created_at: '-',
      };

      this.document_items.push(doc_record);

      this.new_doc_record = {};

    },

    async onUploadFileBulk(order_id) {
      for (let i in this.document_items) {
        let document_item = this.document_items[i];
        await this.onUploadFile(order_id, document_item);
      }
    },

    async onUploadFile(order_id, document_item) {
      // this.loader_full = this.$loading.show({
      //   isFullPage: true,
      //   canCancel: false
      // });

      let formData = new FormData();
      formData.append("doc_file", document_item.upload_file);
      formData.append("document_name", document_item.document_name);
      formData.append("order_master_id", order_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_upload_document.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });
      console.log(response);
      if (response) {
        // this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
      // this.getOrderMaster_Docs();
    },

    async getAddresseTemplates() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "address_template_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      this.address_template_data = response.data.templates;
      this.address_template_options = [{
        value: null,
        text: "-"
      }];
      for (let i in response.data.templates) {
        this.address_template_options.push({
          value: response.data.templates[i].id,
          text: response.data.templates[i].template_name,
        });
      }
    },

    // async getOrderMaster_Docs() {
    //   let response = await this.$http({
    //     method: "POST",
    //     baseURL: `${this.API_HOST}`,
    //     url: "inbound_shipment_doc_get.php",
    //     data: {
    //       inbound_shipment_id: this.$route.params.inbound_shipment_id,
    //       account_type: this.$store.state.user_obj.account_type,
    //       client_id: this.$store.state.user_obj.client_id
    //     }
    //   });
    //   this.document_items = response.data.inbound_shipment_docs;

    //   this.loader.hide();
    // },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.file_document {
  display: none;
}

.preview_img-product {
  max-width: 100%;
  max-height: 200px;
}

.container-preview_img {
  padding: 5px;
}

.icon-add_image {
  color: #cacaca;
}

.col-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-group {
  margin-bottom: 0;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderMasterCreate.vue